import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { rootRoute } from '../../router/routes/rootRoute';

export const versionRoute = createRoute({
	path: '/version',
	getParentRoute: () => rootRoute,
	component: lazyRouteComponent(() => import('./VersionPage'), 'VersionPage'),
	staticData: {
		disableAuthGuard: true,
	},
});
